<div fxLayout="column" fxLayoutAlign="center" class="main-container">
  <div class="main-content">
    <div fxLayout="column" fxLayoutAlign="center space-around" class="content-wrapper app-card-center">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
